export const pharmacy = {
  // Вкладка «Мониторинг препаратов»
  monitoring: {
    viewDrugs: '[perm]-[pharmacy]-monitoring-view-drugs',
    addDrug: '[perm]-[pharmacy]-monitoring-add-drug',
    expenseDrugs: '[perm]-[pharmacy]-monitoring-expense-drugs',
    viewDrugInfo: '[perm]-[pharmacy]-monitoring-view-drug-info',
    addDrugBatch: '[perm]-[pharmacy]-monitoring-add-drug-batch',
    deleteDrugBatch: '[perm]-[pharmacy]-monitoring-delete-drug-batch',
    updateDrugAmount: '[perm]-[pharmacy]-monitoring-update-drug-amount',
    deleteDrug: '[perm]-[pharmacy]-monitoring-delete-drug',
  },

  // Вкладка «Справочник ветеринарных препаратов»
  dictionary: {
    viewDrugs: '[perm]-[pharmacy]-dictionary-view-drugs',
    addDrug: '[perm]-[pharmacy]-dictionary-add-drug',
    viewDrug: '[perm]-[pharmacy]-dictionary-view-drug',
    editDrug: '[perm]-[pharmacy]-dictionary-edit-drug',
    addDrugUseInformation: '[perm]-[pharmacy]-dictionary-add-drug-use-information',
    editDrugUseInformation: '[perm]-[pharmacy]-dictionary-edit-drug-use-information',
    deleteDrugUseInformation: '[perm]-[pharmacy]-dictionary-delete-drug-use-information',
    deleteDrug: '[perm]-[pharmacy]-dictionary-delete-drug',
  },
} as const;
